/* eslint-disable no-undef */
import Routing from './router';

const App = () => {
  return (
    <div className="app">
      <Routing />
    </div>
  );
};

export default App;
